'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pt_BR = require('../../date-picker/locale/pt_BR');

var _pt_BR2 = _interopRequireDefault(_pt_BR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _pt_BR2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/pt_BR.tsx
 ** module id = 706
 ** module chunks = 1
 **/